export const locationsData = (state) => state.locations.data;
